export default __webpack_public_path__ + "static/media/101.47d44d0e.svg";